<template>
	<v-card
		class="text-center mx-auto"
		flat
		max-width="400"
		width="100%"
	>
	<!-- class="py-8 px-6 text-center mx-auto ma-4" -->
		<h3 class="text-h6 mb-4">Iдентифікація страхового випадку</h3>

		<div class="text-body-2">
			Вам було надіслано СМС від контакт-центру з реєстраційним номером страхового повідомлення.<br>
			Введіть, будь-ласка, номер страхового повідомлення, отриманий в СМС, та номер Вашого автомобіля
		</div>

		<v-form ref="form">
			<v-sheet color="surface" class="my-6">
				<v-otp-input
					v-model="value.ClaimNumber"
					length="5"
					variant="solo"
					color_="secondary"
					:rules="[rules.required]"
					@keydown.ctrl.z="value.ClaimNumber=12345"
				></v-otp-input>
			</v-sheet>

			<v-sheet color="surface" class="my-6">
				<v-text-field
					v-model="value.VehicleNumber"
					label="Номер автомобіля"
					variant="outlined"
					maxlength="12"
					:rules="[rules.required]"
					@keydown.ctrl.z="value.VehicleNumber='AA1234BB'"
					@keydown.ctrl.x="showDefault = !showDefault"
				>
				</v-text-field>
			</v-sheet>
		</v-form>

		<div class="text-caption my-6">
			Ви не отримали СМС? <a href="#" @click.prevent="value.VehicleNumber = ''">Resend</a>
		</div>
	</v-card>
</template>

<script>
//import {defineComponent, defineExpose} from 'vue';
import mixin from './mixin/main'

export default {
	mixins: [mixin],
	components: {

	},

	props: {
		modelValue:			{ type: Object, default: () => {} },
	},
}
</script>
